"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessType = void 0;
var ProcessType;
(function (ProcessType) {
    ProcessType["Change"] = "change";
    ProcessType["Submit"] = "submit";
    ProcessType["Save"] = "save";
})(ProcessType || (exports.ProcessType = ProcessType = {}));
